/* tslint:disable */
/* eslint-disable */
/**
 * ClimatePartner API Calculation Service
 * A Unified API for all ClimatePartner products
 *
 * The version of the OpenAPI document: 1.6.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ChoiceValuesResponse } from '../models';
// @ts-ignore
import type { CommonErrorBadGateway } from '../models';
// @ts-ignore
import type { CommonErrorBadRequest } from '../models';
// @ts-ignore
import type { CommonErrorGatewayTimeout } from '../models';
// @ts-ignore
import type { CommonErrorInternalServerError } from '../models';
// @ts-ignore
import type { CommonErrorNotFound } from '../models';
// @ts-ignore
import type { CommonErrorPayloadTooLarge } from '../models';
// @ts-ignore
import type { CommonErrorUnauthorized } from '../models';
// @ts-ignore
import type { CommonErrorUnsupportedMediaType } from '../models';
/**
 * CalculationServiceApi - axios parameter creator
 */
export const CalculationServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get possible input values for given choice
         * @param {string} choiceSlug 
         * @param {string} [cursor] Marks the last item return in the previous page. Use this to walk through paginated choices
         * @param {string} [limit] Determines number of choices to return per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChoiceValues: async (choiceSlug: string, cursor?: string, limit?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'choiceSlug' is not null or undefined
            assertParamExists('getChoiceValues', 'choiceSlug', choiceSlug)
            const localVarPath = `/calculation/v1/choices/{choiceSlug}`
                .replace(`{${"choiceSlug"}}`, encodeURIComponent(String(choiceSlug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalculationServiceApi - functional programming interface
 */
export const CalculationServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalculationServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get possible input values for given choice
         * @param {string} choiceSlug 
         * @param {string} [cursor] Marks the last item return in the previous page. Use this to walk through paginated choices
         * @param {string} [limit] Determines number of choices to return per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChoiceValues(choiceSlug: string, cursor?: string, limit?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChoiceValuesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChoiceValues(choiceSlug, cursor, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CalculationServiceApi.getChoiceValues']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CalculationServiceApi - factory interface
 */
export const CalculationServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalculationServiceApiFp(configuration)
    return {
        /**
         * 
         * @summary Get possible input values for given choice
         * @param {CalculationServiceApiGetChoiceValuesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChoiceValues(requestParameters: CalculationServiceApiGetChoiceValuesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChoiceValuesResponse> {
            return localVarFp.getChoiceValues(requestParameters.choiceSlug, requestParameters.cursor, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getChoiceValues operation in CalculationServiceApi.
 */
export interface CalculationServiceApiGetChoiceValuesRequest {
    readonly choiceSlug: string

    /**
     * Marks the last item return in the previous page. Use this to walk through paginated choices
     */
    readonly cursor?: string

    /**
     * Determines number of choices to return per page
     */
    readonly limit?: string
}

/**
 * CalculationServiceApi - object-oriented interface
 */
export class CalculationServiceApi extends BaseAPI {
    /**
     * 
     * @summary Get possible input values for given choice
     * @param {CalculationServiceApiGetChoiceValuesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getChoiceValues(requestParameters: CalculationServiceApiGetChoiceValuesRequest, options?: RawAxiosRequestConfig) {
        return CalculationServiceApiFp(this.configuration).getChoiceValues(requestParameters.choiceSlug, requestParameters.cursor, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }
}

